import { render, staticRenderFns } from "./DashboardSelectCategory.vue?vue&type=template&id=b3c061ac&scoped=true&"
import script from "./DashboardSelectCategory.vue?vue&type=script&lang=js&"
export * from "./DashboardSelectCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c061ac",
  null
  
)

export default component.exports